import type { Component } from "solid-js";
import { isNil } from "lodash-es";
import { useTypedSearchParams } from "../utils/solidRouterUtil";
import { nullish, object, string } from "valibot";
import { useNavigate } from "@solidjs/router";

const QueryParamsSchema = object({ id: nullish(string()), error: nullish(string()) });

const postMessage = (opener: Window, data: { error: string } | { accountId: string }) => {
  opener.postMessage({ messageType: "com.moreapp.oauth", ...data });
  window.close();

  return <></>;
};

const OAuth2CallbackPage: Component = () => {
  const navigate = useNavigate();
  const [params] = useTypedSearchParams(QueryParamsSchema);

  const opener = window.opener as Window | null;
  if (isNil(opener)) {
    // No 'opener' means that someone ended up on this page by navigating directly to this URL. This is not a valid case,
    // so just redirect them to '/'.
    navigate("/");
  } else if (!isNil(params.error)) {
    return postMessage(opener, { error: params.error });
  } else if (!isNil(params.id)) {
    return postMessage(opener, { accountId: params.id });
  }

  throw new Error("Unknown error during OAuth2 flow");
};

export default OAuth2CallbackPage;
